(ns practitest.frontend.tests.test-form.smartfox-modal
  (:require [ajax.core :as ajax]
            [clojure.set]
            [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.modal :as modal]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.dropdown :as dropdown]
            [practitest.frontend.components2.entity-form.forms :as forms]
            [practitest.frontend.components2.feedback :as feedback]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.tests.test-form.common :refer [init-step-form-object
                                                                random-step-id
                                                                steps-form-id
                                                                test-form-id
                                                                index-of
                                                                next-item
                                                                prev-item
                                                                new-state-id]]
            [re-frame.core :as re-frame]))

(def modal-id :smartfox-test-steps-modal)
;; TODO: from backend ?
(def default-prompt-no-steps "Please create a test scenario with up to 10 steps based on the provided title or description")

;;; Helpers
(comment
  ;; History model
  :states-list [:id1 :id2 :id3]
  :current-state-id :id2
  :states {:id1 {:loading? true
                 :selection #{}}
           :id2 {:loding? true
                 :steps {}}
           :id3 {}})

(comment
  (def states-list [:id1 :id2])
  (index-of states-list :id2)
  (next-item states-list :id2)
  (prev-item states-list :id1))

(defn- get-steps-for-backend
  [db state-id]
  (map (fn [step]
         (let [smartfox-step (select-keys step [:id :position :name :description :expected_results])]
           ;; Special case for "new" steps that were added on previous smartfox generation step
           ;; They will have an id assigned on previous iteration but we need to remove it before sending
           ;; Data to smartfox, because it will treat them as "existing" step and will confuse everything
           (if (:new? step)
             (dissoc smartfox-step :id)
             smartfox-step)))
       (sort-by :position (vals (get-in db [:form-states2 modal-id :states state-id :steps])))))

(defn- init-steps-from-parent-form
  [db]
  (into
    {}
    (map (fn [step-form-state]
           [(:id step-form-state)
            {:id (:id step-form-state)
             :position (:position step-form-state)
             :name (get-in step-form-state [:fields :name :value])
             :description (get-in step-form-state [:fields :description :value])
             :expected_results (get-in step-form-state [:fields :expected_results :value])}]))
    (vals (get-in db [:form-states2 steps-form-id :steps]))))

(defn- get-field-from-db
  [db field-id]
  (get-in db [:form-states2 test-form-id :fields field-id :value]))

(defn- rollback-state
  [db]
  (let [new-states-list (pop (get-in db [:form-states2 modal-id :states-list]))]
    (-> db
        (update-in [:form-states2 modal-id]
                   (fn [form-state]
                     ;; Revert state back to previous without leaving history
                     (assoc form-state
                            :states-list new-states-list
                            :current-state-id (last new-states-list)))))))

(defn- select-all-steps
  [db]
  (let [current-state-id (get-in db [:form-states2 modal-id :current-state-id])
        all-ids (set (map :id (vals (get-in db [:form-states2 modal-id :states current-state-id :steps]))))]
    (assoc-in db [:form-states2 modal-id :selected-steps] all-ids)))

(defn- enrich-steps [steps]
  (into {}
        (map-indexed (fn [idx step-response]
                       (let [step-id (or (:id step-response)
                                         (random-step-id))
                             position (or (:position step-response)
                                          (inc idx))]
                         [step-id (assoc step-response
                                                                    ;; Mark step as "new" - if it's without ID then it's new generated step
                                         :new? (nil? (:id step-response))
                                         :id step-id
                                         :position position)])))
        steps))

(defn- get-field-value [form-props field]
  (let [get-field-state (:get-field-state form-props)
        field-state (and (some? get-field-state)
                         @(get-field-state field))]
    (:value field-state)))

;;; Subscriptions

(re-frame/reg-sub
  ::state
  (fn [db]
    (get-in db [:form-states2 modal-id])))

(re-frame/reg-sub
  ::show-modal?
  :<- [::state]
  (fn [state]
    (:show-modal? state)))

(re-frame/reg-sub
  ::current-state
  :<- [::state]
  (fn [state]
    (get-in state [:states (:current-state-id state)])))

(re-frame/reg-sub
  ::next-state-id
  :<- [::state]
  (fn [{:keys [states-list current-state-id]}]
    (next-item states-list current-state-id)))

(re-frame/reg-sub
  ::prev-state-id
  :<- [::state]
  (fn [{:keys [states-list current-state-id]}]
    (prev-item states-list current-state-id)))

(re-frame/reg-sub
  ::current-selection
  :<- [::state]
  (fn [state]
    (:selected-steps state)))

(re-frame/reg-sub
  ::step-selected?
  :<- [::current-selection]
  (fn [selection [_ step]]
    (contains? selection (:id step))))

(re-frame/reg-sub
  ::all-selected?
  :<- [::current-selection]
  :<- [::current-steps]
  (fn [[selection steps]]
    (clojure.set/subset?
      (set (map :id steps))
      selection)))

(re-frame/reg-sub
  ::current-steps
  :<- [::current-state]
  (fn [state]
    (sort-by :position (vals (:steps state)))))

(re-frame/reg-sub
  ::selected-steps
  :<- [::current-selection]
  :<- [::current-state]
  (fn [[selection state]]
    (sort-by :position (vals (select-keys (:steps state) selection)))))

(re-frame/reg-sub
  ::current-user-prompt
  :<- [::state]
  (fn [state]
    (:user-prompt state)))

(re-frame/reg-sub
  ::show-replace-warning?
  :<- [::state]
  (fn [state]
    (:show-replace-warning? state)))

;;; Events

(re-frame/reg-event-db
  ::toggle-selection
  (fn [db [_ selected? step]]
    (update-in db
               [:form-states2 modal-id :selected-steps]
               (if selected?
                 (fnil conj #{})
                 disj)
               (:id step))))

(re-frame/reg-event-db
  ::toggle-selection-all
  (fn [db [_ selected?]]
    (let [steps @(re-frame/subscribe [::current-steps])]
      (assoc-in db
                [:form-states2 modal-id :selected-steps]
                (if selected?
                  (set (map :id steps))
                  #{})))))

(re-frame/reg-event-db
  ::hide-modal
  (fn [db]
    (assoc-in db [:form-states2 modal-id :show-modal?] false)))

(re-frame/reg-event-db
  ::toggle-replace-warning
  (fn [db [_ show? selected-steps]]
    (let [base-db (assoc-in db [:form-states2 modal-id :show-replace-warning?] show?)]
      (if show?
        (assoc-in base-db [:form-states2 modal-id :pending-selected-steps] selected-steps)
        (update-in base-db [:form-states2 modal-id] dissoc :pending-selected-steps)))))

(re-frame/reg-event-fx
  ::confirm-replace-steps
  (fn [{db :db}]
    (let [selected-steps (get-in db [:form-states2 modal-id :pending-selected-steps])]
      {:db (-> db
               (assoc-in [:form-states2 modal-id :show-replace-warning?] false)
               (update-in [:form-states2 modal-id] dissoc :pending-selected-steps))
       :dispatch [::replace-steps selected-steps]})))

(re-frame/reg-event-db
  ::update-user-prompt
  (fn [db [_ value]]
    (assoc-in db [:form-states2 modal-id :user-prompt] value)))

(re-frame/reg-event-fx
  ::apply-action
  (fn [{db :db} [_ state-id]]
    (let [current-state-id (get-in db [:form-states2 modal-id :current-state-id])]
      {:db         (-> db
                       (update :progress conj ::apply-action)
                       ;; Only of state-id is new (edge case for new steps generation)
                       (cond-> (not= state-id current-state-id)
                               (update-in [:form-states2 modal-id]
                                          (fn [form-state]
                                            (-> form-state
                                                (assoc :current-state-id state-id)
                                                (update :states-list conj state-id))))))
       :http-xhrio {:method          :post
                    :uri             (broutes/get-url "qtest_designs#smart_fox_apply2"
                                                      {:p_id (subs/get-current-project-id db)})
                    :params          {:name        (get-field-from-db db :name)
                                      :description (get-field-from-db db :description)
                                      :steps       (get-steps-for-backend db (get-in db [:form-states2 modal-id :current-state-id]))
                                      :user_prompt (get-in db [:form-states2 modal-id :user-prompt])}
                    :format          (ajax/json-request-format)
                    :response-format (ajax/json-response-format {:keywords? true})
                    :on-success      [::apply-completed state-id]
                    :on-request      [::track-request state-id]
                    :on-failure      [::apply-failed]}})))

(re-frame/reg-event-db
  ::track-request
  (fn [db [_ _state-id xhrio]]
    (assoc-in db [:form-states2 modal-id :pending-request] xhrio)))

(re-frame/reg-event-fx
  ::abort-current-request
  (fn [{db :db}]
    (when-let [xhrio (get-in db [:form-states2 modal-id :pending-request])]
      (ajax/abort xhrio))
    {}))

(re-frame/reg-event-fx
  ::apply-completed
  (fn [{db :db} [_ state-id response]]
    (let [db (-> db
                 (update :progress disj ::apply-action)
                 (update-in [:form-states2 modal-id] dissoc :pending-request))
          warning (:warning response)
          error (:error response)]
      (if (or error warning)
        {:db (rollback-state db)
         :dispatch (if warning
                     ;; Now that would be ChatGPT returned error
                     [::notifications/warning2 warning {:auto-close 15000}]
                     ;; This would be something like network error
                     [::notifications/error2 error {:auto-close 15000}])}
        {:db (-> db
                 (assoc-in [:form-states2 modal-id :states state-id :steps]
                           (enrich-steps (:steps response)))
                 (select-all-steps))}))))

(re-frame/reg-event-fx
  ::apply-failed
  (fn [{db :db} [_ response]]
    (let [db (-> db
                 (update :progress disj ::apply-action)
                 (update-in [:form-states2 modal-id] dissoc :pending-request)
                 (rollback-state))]
      (if (= :aborted (:failure response))
        {:db db}
        {:db db
         :dispatch [::notifications/error2
                    (get-translation "generic.error.network-error" "Error fetching data from server")
                    {:auto-close 5000}]}))))

(re-frame/reg-event-fx
  ::generate-steps
  (fn [{db :db} [_]]
    {:db (update db :progress conj ::generate-steps)
     :http-xhrio {:method          :post
                  :uri             (broutes/get-url "qtest_designs#smart_fox_apply2"
                                                    {:p_id (subs/get-current-project-id db)})
                  :params          {:name        (get-field-from-db db :name)
                                    :description (get-field-from-db db :description)
                                    :user_prompt default-prompt-no-steps}
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::generate-steps-completed]
                  :on-failure      [::generate-steps-failed]}}))

(re-frame/reg-event-fx
  ::generate-steps-completed
  (fn [{db :db} [_ response]]
    (let [warning (:warning response)
          error (:error response)
          db (update db :progress disj ::generate-steps)]
      (if (or error warning)
        {:db (rollback-state db)
         :dispatch (if warning
                     [::notifications/warning2 warning {:auto-close 15000}]
                     [::notifications/error2 error {:auto-close 15000}])}
        {:db db
         :dispatch [::apply-step-changes (set (vals (enrich-steps (:steps response))))]}))))

(re-frame/reg-event-fx
  ::generate-steps-failed
  (fn [{db :db} [_]]
    {:db (update db :progress disj ::generate-steps)
     :dispatch [::notifications/error2
                (get-translation "generic.error.network-error" "Error fetching data from server")
                {:auto-close 5000}]}))

(re-frame/reg-event-db
  ::set-current-state-id
  (fn [db [_ state-id]]
    (-> db
        (assoc-in [:form-states2 modal-id :current-state-id] state-id)
        (select-all-steps))))

(re-frame/reg-event-fx
  ::show-modal
  (fn [{db :db}]
    (let [state-id (new-state-id)
          steps (init-steps-from-parent-form db)]
      {:db (-> db
               (assoc-in [:form-states2 modal-id]
                         {:current-state-id state-id
                          :user-prompt (if (empty? steps)
                                         default-prompt-no-steps
                                         "")
                          :show-modal? true
                          :states {state-id {:steps steps}}
                          :states-list [state-id]
                          :selected-steps (set (keys steps))}))
       :dispatch (when (empty? steps)
                   [::apply-action state-id])})))

(re-frame/reg-event-fx
  ::apply-step-changes
  (fn [{db :db} [_ selected-steps]]
    {:db (-> db
             (update-in [:form-states2 steps-form-id :steps]
                        (fn [steps]
                          (reduce
                            (fn [steps new-step]
                              (let [step-form-object (init-step-form-object
                                                       (:id new-step)
                                                       (:position new-step)
                                                       true
                                                       (assoc new-step :type :step))]
                                (assoc steps (:id new-step) step-form-object)))
                            {}
                            selected-steps)))
             (assoc-in [:form-states2 steps-form-id :dirty?] true)
             (assoc-in [:form-states2 steps-form-id :smartfox-used?] true))
     :dispatch [::hide-modal]}))

(re-frame/reg-event-fx
  ::replace-steps
  (fn [{db :db} [_ selected-steps]]
    {:db (-> db
             ;; Mark all old steps as deleted
             (assoc-in [:form-states2 steps-form-id :steps-to-remove]
                       (set (keys (get-in db [:form-states2 steps-form-id :steps]))))
             (assoc-in [:form-states2 steps-form-id :steps]
                       (reduce
                         (fn [steps new-step]
                           ;; New id in case of "Replace Steps"
                           (let [id (random-step-id)
                                 step-form-object (init-step-form-object
                                                    id
                                                    (:position new-step)
                                                    true
                                                    (assoc new-step :type :step))]
                             (assoc steps id
                                          (assoc step-form-object :smartfox-step? true))))
                         {}
                         selected-steps))
             (assoc-in [:form-states2 steps-form-id :dirty?] true)
             (assoc-in [:form-states2 steps-form-id :smartfox-used?] true))
     :dispatch [::hide-modal]}))

(re-frame/reg-event-fx
  ::add-new-steps
  (fn [{db :db} [_ selected-steps]]
    {:db (-> db
             (update-in [:form-states2 steps-form-id :steps]
                        (fn [steps]
                          (let [start-pos (count steps)]
                            (reduce
                              (fn [steps new-step]
                                ;; New id in case of "Add as new steps" as well
                                (let [id (random-step-id)
                                      step-form-object (init-step-form-object
                                                         id
                                                         ;; Add to the end of form
                                                         (+ start-pos (:position new-step))
                                                         true
                                                         (assoc new-step :type :step))]
                                  (assoc steps id
                                               (assoc step-form-object :smartfox-step? true))))
                              steps
                              selected-steps))))
             (assoc-in [:form-states2 steps-form-id :dirty?] true)
             (assoc-in [:form-states2 steps-form-id :smartfox-used?] true))
     :dispatch [::hide-modal]}))

;;; Internal components

(defn- checkbox
  [{:keys [value class disabled? on-change]}]
  [:input.m-checkbox
   {:type "checkbox"
    :class class
    :checked value
    :disabled disabled?
    :on-change on-change}])

(defn- smartfox-step
  [step]
  [:div.smartfox-step-item
   {:key (:id step)}
   ;; Technically we don't need all selection-related code anymore but I'm a bit
   ;; afraid that there would be a task to restore them so decided not to clean all selection-related logic for now
   ;; Will need to be cleaned up at the next iteration of smartfox development
   #_[:div.selector-column
      [checkbox
       {:on-change (fn [e]
                     (re-frame/dispatch [::toggle-selection (dom/event-value e) step]))
        :value @(re-frame/subscribe [::step-selected? step])}]]
   [:div.step-number-column
    (str (:position step))]
   [:div.step-name-column
    (:name step)]
   [:div.description-column
    (:description step)]
   [:div.expected-results-column
    (:expected_results step)]])

;;; Public components

(defn replace-warning-dialog []
  (let [show-warning? @(re-frame/subscribe [::show-replace-warning?])]
    [modal/bootstrap-modal
     {:is-open? show-warning?
      :on-request-close #(re-frame/dispatch [::toggle-replace-warning false nil])
      :class "replace-warning-modal"
      :close-button? true}
     [:div
      (get-translation "test.smartfox.replace-warning-title" "Confirm Replace")]
     [:div
      [:p (get-translation "test.smartfox.replace-warning-message" 
                          "Note, Your current steps include attachments and comments. Replacing them will remove them. Do you want to continue?")]]
     [:<>
      [buttons/button
       {:text (get-translation "generic.button.cancel" "Cancel")
        :secondary? true
        :on-click #(re-frame/dispatch [::toggle-replace-warning false nil])}]
      [buttons/button
       {:text (get-translation "generic.button.continue" "Continue")
        :primary? true
        :on-click #(re-frame/dispatch [::confirm-replace-steps])}]]]))

(defn smartfox-modal [form-props]
  (let [show? (re-frame/subscribe [::show-modal?])
        hide! #(re-frame/dispatch [::hide-modal])]
    (fn [{:keys [entity-type entity-id] :as form-props}]
      (let [loading? @(re-frame/subscribe [::subs/progress? ::apply-action])
            steps @(re-frame/subscribe [::current-steps])]
        [:<>
         [modal/bootstrap-modal
          {:is-open? @show?
           :on-request-close hide!
           :container-ref (:main-ref form-props)
           :class "smartfox-steps-modal"
           :close-button? true}
         ;; header
          [:div.smartfox-modal-header
           (get-translation "test.smartfox.modal-header" "Step Generator - Generate or Refine Steps Using AI")]
         ;; body
          [:div.smartfox-modal-body
           [:div.smartfox-test-name
            [:span.label
             (format-translation
              (get-translation "test.smartfox.test-name-label" "Test Name:"))]
            (get-field-value form-props :name)]
           [:div.smartfox-steps
            [:div.smartfox-steps-header
             #_[:div.header-column
                [checkbox
                 {:on-change (fn [e]
                               (re-frame/dispatch [::toggle-selection-all (dom/event-value e)]))
                  :value (if (seq steps)
                           @(re-frame/subscribe [::all-selected?])
                           false)}]]
            ;; Reusing translation strings from steps editor here
             [:div.header-column (get-translation "test.step.column-header-number" "Step #")]
             [:div.header-column (get-translation "test.step.column-header-name" "Step Name")]
             [:div.header-column (get-translation "test.step.column-header-description" "Description")]
             [:div.header-column (get-translation "test.step.column-header-expected-results" "Expected Results")]]
            [:div.smartfox-steps-scrollable-parent
             (into
              [:div.smartfox-steps-scrollable-container]
              (map (fn [item]
                     [smartfox-step item]))
              steps)
             (when loading?
               [:div.smartfox-loading-container
                [spinners/mux-spinner
                 {:size :medium}]
                [:div.loading-information-string
                 (get-translation "test.smartfox.loading-string" "Please wait .... Generating Steps")]])]]

           [:div.smartfox-bottom-toolbar
           ;; Disabled for now, because backend part is not ready yet
            [feedback/feedback-component {:entity-type entity-type
                                          :entity-id entity-id
                                          :feature "smartfox-modal"}]
            (let [prev-state-id @(re-frame/subscribe [::prev-state-id])]
              [buttons/icon-button
               {:icon [icons/mux-undo]
                :disabled? (or loading?
                               (nil? prev-state-id))
                :on-click (fn [e]
                            (re-frame/dispatch [::set-current-state-id prev-state-id]))}])
            (let [next-state-id @(re-frame/subscribe [::next-state-id])]
              [buttons/icon-button
               {:icon [icons/mux-redo]
                :disabled?  (or loading?
                                (nil? next-state-id))
                :on-click (fn [e]
                            (re-frame/dispatch [::set-current-state-id next-state-id]))}])
            (let [selected-steps @(re-frame/subscribe [::selected-steps])
                  edit-mode? @(re-frame/subscribe [::has-existing-saved-steps?])]
              (if edit-mode?
                [dropdown/dropdown-button
                 {:text (get-translation "test.smartfox.apply-steps-button" "Apply Steps")
                  :primary? true}
                ;; Nested inside modal, absolute doesn't work correctly here
                 {:strategy "fixed"
                  :placement "bottom-start"}
                 [dropdown/dropdown-menu-item
                  {:text (get-translation "test.smartfox.replace-steps-button" "Replace Steps")
                   :on-click (fn [_]
                               (if @(re-frame/subscribe [::has-steps-with-attachments-or-comments?])
                                 (re-frame/dispatch [::toggle-replace-warning true selected-steps])
                                 (re-frame/dispatch [::replace-steps selected-steps])))}]
                 [dropdown/dropdown-menu-item
                  {:text (get-translation "test.smartfox.add-as-new-steps-button" "Add as new Steps")
                   :on-click (fn [_]
                               (re-frame/dispatch [::add-new-steps selected-steps]))}]]
                [buttons/button
                 {:primary?  true
                  :disabled? (or loading?
                                 (empty? selected-steps))
                  :text      (get-translation "test.smartfox.apply-steps-button" "Apply Steps")
                  :on-click  (fn [_e] 
                               (re-frame/dispatch [::apply-step-changes selected-steps])
                               (hide!))}]))]]
         ;; footer
          [:div.smartfox-modal-footer
           [:div.smartfox-input-prompt-container
            [:input.m-input
             {:value @(re-frame/subscribe [::current-user-prompt])
              :placeholder (get-translation "test.smartfox.user-prompt-placeholder" "Input your request to Step Generator here")
              :on-change (fn [e]
                           (re-frame/dispatch-sync [::update-user-prompt (dom/event-value e)]))}]
            [buttons/button
             {:primary? true
              :class "smartfox-apply-button"
              :disabled? (str/blank? @(re-frame/subscribe [::current-user-prompt]))
              :on-click (fn [e]
                          (if loading?
                            (re-frame/dispatch [::abort-current-request])
                            (re-frame/dispatch [::apply-action (new-state-id)])))
              :icon  (if loading?
                       [icons/mux-stop-icon]
                       [icons/mux-arrow-right])}]]]]
         [replace-warning-dialog]]))))

(re-frame/reg-sub
  ::has-existing-saved-steps?
  :<- [::forms/form-state steps-form-id]
  (fn [steps-form-state]
    (boolean (seq (remove :new? (vals (:steps steps-form-state)))))))

(re-frame/reg-sub
  ::has-steps-with-attachments-or-comments?
  (fn [db]
    (let [steps-data (get-in db [:entity :test :steps])]
      (boolean (some (fn [step]
                       (or (seq (:attachments step))
                           (seq (:comments step))))
                     steps-data)))))

(defn smartfox-toolbar-button
  [form-props]
  (let [edit-permissions? (:edit-permissions? form-props)
        edit-locked? (:edit_locked (:base-entity form-props))
        title-value (get-field-value form-props :name)
        description-value (get-field-value form-props :description)
        disabled-reason (cond
                          (not @(re-frame/subscribe [::subs/generative-ai-consent?]))
                          :no-ai-consent

                          (and (str/blank? title-value)
                               (str/blank? description-value))
                          :no-title-or-description

                          (not edit-permissions?)
                          :no-permission

                          edit-locked?
                          :edit-locked)
        disabled-tooltip (case disabled-reason
                           :no-ai-consent
                           (get-translation "test.smartfox.no-ai-consent-tooltip"
                                            "Generative AI consent is needed for this account")

                           :no-title-or-description
                           (get-translation "test.smartfox.no-title-description-tooltip"
                                            "To activate Step Generator, please provide a title or description for your test.")

                           :has-saved-steps
                           (get-translation "test.smartfox.unsaved-steps-only"
                                            "Step Generator only available in tests without saved steps for now")

                           ;; default
                           nil)
        disabled? (some? disabled-reason)]
    [tooltip/mux-tooltip
     {}
     disabled-tooltip
     (fn [props]
       [:span
        (if disabled-tooltip
          props
          {})
        [buttons/button
         {:text (get-translation "test.steps.toolbar-smart-fox-label" "Step Generator")
          :title (get-translation "test.steps.toolbar-smart-fox-label" "Step Generator")
          :disabled? disabled?
          :on-click (fn []
                      (mixpanel/track "AI Generate Steps")
                      (re-frame/dispatch [::show-modal]))
          :class "hide-text"
          :icon [icons/mux-smart-fox2]}]])]))

